<template>
    <div id="pixon-carousel" class="carousel slide carousel-fade">
        <template v-if="items.length > 1">
            <ul class="carousel-indicators">
                <li
                    v-for="(item, index) in items" :key="index"
                    data-bs-target="#pixon-carousel"
                    :data-bs-slide-to="index"
                    :class="index == 0 ? 'active' : ''"
                    aria-current="true"
                    aria-label="Slide 1"
                ></li>
            </ul>
        </template>
        <div class="carousel-inner">
            <template v-for="(item, index) in items" :key="index">
                <div
                    class="carousel-item"
                    :class="index == 0 ? 'active' : '' "
                    data-bs-interval="0"
                >
                    <template v-if="item.image !== undefined && item.image != ''">
                        <div class="carousel-bg" :style="`background-image: url('${item.image}');`"></div>
                    </template>
                    <template v-else-if="item.link !== undefined && item.link != ''">
                        <div class="carousel-youtube-backdrop"></div>

                        <div class="videoContainer">
                            <iframe
                                :src="`https://youtube.com/embed/${item.link.split('=')[1]}?&autoplay=1&mute=1&playsinline=1&playlist=${item.link.split('=')[1]}&controls=0&autoplay=1&showinfo=1&autohide=1&modestbranding=1&fs=0&loop=1&rel=0`"
                            ></iframe>
                        </div>

                    </template>
                    <template v-if="items.length > 1">
                        <div class="carousel-caption d-md-block">
                            <p>{{item.translate[0].title}}</p>
                        </div>
                    </template>
                </div>
            </template>
        </div>

        <template v-if="items.length > 1">
            <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#pixon-carousel"
                data-bs-slide="prev"
            >
                <i class="fas fa-angle-double-left carousel-prev-icon"></i>
                <span class="visually-hidden">Previous</span>
            </button>
            <button
                class="carousel-control-next"
                type="button"
                data-bs-target="#pixon-carousel"
                data-bs-slide="next"
            >
                <i class="fas fa-angle-double-right carousel-next-icon"></i>
                <span class="visually-hidden">Next</span>
            </button>
        </template>
    </div>
</template>


<script>
    // import { onMounted } from "vue";

    export default {
        name: "CarouselC",
        props: ["items"],
        setup() {

            // onMounted(() => {
            // });

            return {};
        },
    };
</script>


<style lang="scss">
    .carousel-youtube-backdrop {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #00000030;
    }

    iframe > .ytp-share-button,
    iframe > .ytp-gradient-top,
    iframe > .ytp-chrome-top.ytp-show-cards-title,
    iframe > .ytp-paid-content-overlay,
    iframe > .ytp-watermark.yt-uix-sessionlink {
        display: none !important;
    }

    .videoContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: -999;
    }

    iframe {
        // margin-top: 100px;
        height: calc(100vh - 100px);
        width: 100%;
        // height: 100%;
    }

    // @media (min-aspect-ratio: 16/9) {
    //   .video-container iframe {
    //     /* height = 100 * (9 / 16) = 56.25 */
    //     height: 56.25vw;
    //   }
    // }

    // @media (max-aspect-ratio: 16/9) {
    //   .video-container iframe {
    //     /* width = 100 / (9 / 16) = 177.777777 */
    //     width: 177.78vh;
    //   }
    // }

    .carousel-caption {
        right: unset;
        left: unset;
        width: 100%;
        // background-image: linear-gradient(90deg, rgba(10, 10, 210, 0.7), rgba(0, 0, 0, 0.67));
        // background-image: linear-gradient(
        //         -90deg,
        //         rgba(85, 84, 84, 0.8),
        //         rgba(56, 66, 71, 0.8),
        //         transparent 100%
        //     );
    }
    .carousel-item {
        margin-top: 100px;
        height: calc(100vh - 100px);
    }
    .carousel-bg {
        height: calc(100vh - 100px);
        background-position: top;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .carousel:hover {
        .carousel-next-icon,
        .carousel-prev-icon {
            // display: block;
            opacity: 1;
            transition: all 1250ms cubic-bezier(0.19, 1, 0.22, 1);
        }
    }
    .carousel-next-icon,
    .carousel-prev-icon {
        // display: none;
        opacity: 0;
        transition: all 1250ms cubic-bezier(0.19, 1, 0.22, 1);
        position: absolute;
        // font-size: 14pt;
        padding: 20px;
        border: 1px solid #ffdfb6;
    }
    // .carousel-control-next-icon::before{
    //     content: '>';
    // }
    .carousel-prev-icon {
        // left: -30px;
        left: 0px;
    }
    .carousel-next-icon {
        // right: -30px;
        right: 0px;
    }

    .carousel-indicators{
        list-style: none;
    }

    @media (max-width: 576px) {
        .carousel-next-icon,
        .carousel-prev-icon {
            display: block;
            position: inherit;
        }
        .carousel-prev-icon {
            left: 0px;
        }
        .carousel-next-icon {
            right: 0px;
        }
    }
</style>